module.exports = __webpack_public_path__ + "img/noun_image_trending.47d7c0a4.svg";